"use client";
import { jsxs as e, jsx as i } from "react/jsx-runtime";
import { globalStyles as l } from "../common/styles/global.js";
import { Global as s } from "@emotion/react";
import { createContext as f } from "react";
const m = f(null), o = ({ feAppId: r = "root", children: t }) => /* @__PURE__ */ e(m.Provider, { value: { rootId: r }, children: [
  /* @__PURE__ */ i(s, { styles: l }),
  t
] });
o.displayName = "SkfUiProvider";
const p = o;
export {
  m as SkfUiContext,
  p as default
};
